/**
 * encuestasPlataformaService.js
 * Servicio para encuestas de plataforma (Root Sistema y Respondentes)
 */
import api from './api';

// ==================== ROOT SISTEMA ====================

export const getEncuestasPlataforma = () =>
  api.get('/encuestas-plataforma');

export const crearEncuestaPlataforma = (data) =>
  api.post('/encuestas-plataforma', data);

export const actualizarEncuestaPlataforma = (id, data) =>
  api.put(`/encuestas-plataforma/${id}`, data);

export const eliminarEncuestaPlataforma = (id) =>
  api.del(`/encuestas-plataforma/${id}`);

export const activarEncuestaPlataforma = (id) =>
  api.post(`/encuestas-plataforma/${id}/activar`);

export const cerrarEncuestaPlataforma = (id) =>
  api.post(`/encuestas-plataforma/${id}/cerrar`);

export const getResultadosPlataforma = (id) =>
  api.get(`/encuestas-plataforma/${id}/resultados`);

export const getPreguntasPlataforma = (encuestaId) =>
  api.get(`/encuestas-plataforma/${encuestaId}/preguntas`);

export const crearPreguntaPlataforma = (encuestaId, data) =>
  api.post(`/encuestas-plataforma/${encuestaId}/preguntas`, data);

export const actualizarPreguntaPlataforma = (preguntaId, data) =>
  api.put(`/encuestas-plataforma/preguntas/${preguntaId}`, data);

export const eliminarPreguntaPlataforma = (preguntaId) =>
  api.del(`/encuestas-plataforma/preguntas/${preguntaId}`);

// ==================== RESPONDENTES ====================

export const getEncuestasDisponibles = (esquema) =>
  api.get(`/encuestas-plataforma/disponibles?esquema=${esquema}`);

export const getEncuestaParaResponder = (id, esquema) =>
  api.get(`/encuestas-plataforma/${id}/responder?esquema=${esquema}`);

export const responderEncuestaPlataforma = (id, esquema, respuestas) =>
  api.post(`/encuestas-plataforma/${id}/responder?esquema=${esquema}`, { respuestas });

const encuestasPlataformaService = {
  getEncuestasPlataforma,
  crearEncuestaPlataforma,
  actualizarEncuestaPlataforma,
  eliminarEncuestaPlataforma,
  activarEncuestaPlataforma,
  cerrarEncuestaPlataforma,
  getResultadosPlataforma,
  getPreguntasPlataforma,
  crearPreguntaPlataforma,
  actualizarPreguntaPlataforma,
  eliminarPreguntaPlataforma,
  getEncuestasDisponibles,
  getEncuestaParaResponder,
  responderEncuestaPlataforma
};

export default encuestasPlataformaService;
